import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import {  cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsPlaceResponse } from "../../Orchestrator/Types/Interface/ICmsDestination";



export async function getCmsPlaceDetail(slug: string): Promise<
  IApiResponse<ICmsPlaceResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getFamousPlacesAPI;

  const params = new URLSearchParams({
    "filters[slug][$eq]": slug,
    "populate": "*",
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsPlaceResponse>(endpointWithParams, "GET");
}
